import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { LoginDetails } from "gatsby-theme-gba"

const LoginDetailsEditable = ({ blok }) => (
  <div {...storyblokEditable(blok)} key={blok._uid}>
    <LoginDetails reverse={blok.reverse} />
  </div>
)

export default LoginDetailsEditable
